import script from "./stmanage.vue?vue&type=script&setup=true&lang=js"
export * from "./stmanage.vue?vue&type=script&setup=true&lang=js"

import "./stmanage.vue?vue&type=style&index=0&id=7bb97397&lang=scss"

const __exports__ = script;

export default __exports__